import { Button, CardContent, CircularProgress, Dialog, DialogActions, DialogContent, Grid, IconButton, Paper, Tooltip, Typography, useTheme } from "@mui/material";
import MyTable, { TableRow } from "../../../components/MyTable";
import { TableHeadRows } from "../../../components/MyTable/TableHead";
import { useEffect, useRef, useState } from "react";
import { getUnApprovedPostsRequest, setApprovePostRequest } from "../../../api/employeePortal";
import { useSelector } from "react-redux";
import { RootState } from "../../../store";
import { getDatestring } from "../../../utils/date";
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import PostCard from "../../../components/PostCard";
import { ApprovePostRequest, UnaprovePostData } from "../../../interfaces/post.interface";
import MySnackbar from "../../../components/MySnackbar";

const ApprovePosts = () => {
    const {companyselected} = useSelector((state: RootState) => state.auth);

    const [filterApprovalStatus, setFilterApprovalStatus] = useState<"pending" | "rejected" | "">("")
    const [postList, setPostList] = useState<UnaprovePostData[]>([])
    const [errorMsg, setErrorMsg] = useState("")
    const [successMsg, setSuccessMsg] = useState("")
    const [loading, setLoading] = useState(false);
    const apiHasBeenCalledRef = useRef(false);
    const [loadingUpdate, setLoadingUpdate] = useState(false);
    const [postData, setPostData] = useState<UnaprovePostData | null>(null);

    const handleSetApprovalStatuses = async (postData: UnaprovePostData, approvalStatus: ApprovePostRequest['approvalStatus']) => {
        if (loadingUpdate) {
            return;
        }
        const data: ApprovePostRequest = {
            approvalStatus,
            postType: postData.postType,
            orderTimestamp: postData.orderTimestamp,
        }
        console.log("request data", data)
        setLoadingUpdate(true);
        const result = await setApprovePostRequest(data);
        setLoadingUpdate(false);
        console.log("request response", result)
        if (!result || result?.status !== 200) {
            const msg = typeof result?.data === "string" ? result.data : "Error actualizando la publicación."
            setErrorMsg(msg);
            return;
        }
        const finalData = [...postList].map(p => ({
            ...p,
            approvalStatus: p.orderTimestamp === postData.orderTimestamp
                ? approvalStatus
                : p.approvalStatus
        }))
        setSuccessMsg("Publicación actualizada con éxito.")
        console.log("filterApprovalStatus", filterApprovalStatus)
        setPostList(finalData.filter((p: UnaprovePostData) => p.orderTimestamp !== postData.orderTimestamp));
    }

    const HandleActions = ({row}: {row: TableRow<string, any>}) => {
        const theme = useTheme();
        const [loading, setLoading] = useState(false)
        return (<Grid container direction="row" minWidth="8rem">

            <Tooltip
                title="Ver"
                slotProps={{
                popper: {
                    modifiers: [
                    {
                        name: 'offset',
                        options: {
                        offset: [0, -14],
                        },
                    },
                    ],
                },
                }}
            >
                <IconButton
                    disabled={loadingUpdate || loading}
                    aria-label="Ver documento"
                    onClick={() => setPostData(row as any)}
                    style={{
                        // border: "1px solid #159D65",
                        // background: "#E8F7F1",
                        color: theme.s10palette.S10Blueblue700,
                        minWidth: "2rem",
                        minHeight: "2rem",
                        padding: ".25rem",
                        marginLeft: ".5rem",
                        // marginRight: "1.5rem"
                    }}
                >
                    {loading || loadingUpdate
                        ? <CircularProgress color="primary" size="1rem" />
                        : <RemoveRedEyeOutlinedIcon />
                    }
                </IconButton >
            </Tooltip>
            <Tooltip
                title="Aprobar"
                slotProps={{
                popper: {
                    modifiers: [
                    {
                        name: 'offset',
                        options: {
                        offset: [0, -14],
                        },
                    },
                    ],
                },
                }}
            >
                <IconButton
                    disabled={loadingUpdate || loading}
                    aria-label="Aprobar"
                    onClick={async () => {
                        setLoading(true)
                        await handleSetApprovalStatuses(row as any, "approved")
                        setLoading(false)
                    }}
                    style={{
                        // border: "1px solid #159D65",
                        // background: "#E8F7F1",
                        color: theme.s10palette.S10Blueblue700,
                        minWidth: "2rem",
                        minHeight: "2rem",
                        padding: ".25rem",
                        marginLeft: ".5rem",
                        // marginRight: "1.5rem"
                    }}
                >
                    {loading || loadingUpdate
                        ? <CircularProgress color="primary" size="1rem" />
                        : <CheckIcon color="success" />
                    }
                </IconButton >
            </Tooltip>
            {filterApprovalStatus !== "rejected" && <Tooltip
                title="Rechazar"
                slotProps={{
                popper: {
                    modifiers: [
                    {
                        name: 'offset',
                        options: {
                        offset: [0, -14],
                        },
                    },
                    ],
                },
                }}
            >                
                <IconButton
                    disabled={loadingUpdate || loading}
                    aria-label="rechazar"
                    onClick={async () => {
                        setLoading(true)
                        await handleSetApprovalStatuses(row as any, "rejected");
                        setLoading(false)
                    }}
                    style={{
                        // border: "1px solid #159D65",
                        // background: "#E8F7F1",
                        color: theme.s10palette.S10Blueblue700,
                        minWidth: "2rem",
                        minHeight: "2rem",
                        padding: ".25rem",
                        marginLeft: ".5rem",
                        // marginRight: "1.5rem"
                    }}
                >
                    {loading || loadingUpdate
                        ? <CircularProgress color="primary" size="1rem" />
                        : <CloseIcon color="error" />
                    }
                </IconButton >
            </Tooltip>}
        </Grid>)
    }


    const tableHeadRows = [
        {
            label: "Publicado Por",
            rowKeyName: "createdByName",
        },{
            label: "Estado",
            rowKeyName: "status",
            customValue: (_head: any, row: TableRow<string, any>) => 
                !row.approvalStatus 
                    ? "Pendiente"
                    : "Rechazado"  
        },{
            label: "Texto",
            rowKeyName: "text",
            // allowOrderAction: true,
        },{
            label: "Media",
            rowKeyName: "media",
            customValue: (headRow: TableHeadRows, row: TableRow<string, any>) => {
                return row.mediaUrls 
                        ? row.mediaUrls?.map((u: string) => u.split(".")?.slice(-1)).join(", ")
                        : "No"
            }
        }, {
            label: "Publicado el",
            rowKeyName: "createdAt",
            customValue: (_: TableHeadRows, row: TableRow<string, any>) => {
                return getDatestring(new Date(row.createdAt * 1000))
            },
        }, {
            label: "Nivel de autorización",
            rowKeyName: "authorizationLevelName",
        }, {
            label: "",
            rowKeyName: "actions",
            customValue: (_head: any, row: TableRow<string, any>) => <HandleActions row={row} />
        },
    ]

    const getPosts = async () => {
        if (!companyselected?.Token || loading || apiHasBeenCalledRef.current) {
            return
        }
        setLoading(true);
        const result = await getUnApprovedPostsRequest({postType: 'unapprovedPost'});
        setLoading(false);
        if (result?.status !== 200) {
            const msg = typeof result.data === "string" ? result.data : "No fue posible obtener los posts."
            console.error(result)
            setErrorMsg(msg)
            return;
        }
        console.log(result.data.message)
        setPostList(result.data.message.Items)
        setLoading(false);
    }

    useEffect(() => {
        if (companyselected?.Token && !loading && !apiHasBeenCalledRef.current) {
            getPosts()
            apiHasBeenCalledRef.current = true;
        }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [companyselected?.Token, filterApprovalStatus])

    return (
        <Grid item width="100%" marginTop="1.5rem" minHeight="60%">
            <Paper 
                elevation={3}
                style={{
                    width: "100%", 
                    borderRadius: "0.5rem",
                    minHeight: "10rem",
                    padding: "2rem 1.5rem"
                }}
            >
                <MyTable
                    key="tab-0"
                    hiddenSearchInput={true}
                    tableHeadRows={tableHeadRows}
                    tableRows={postList}
                    loading={loading}
                    selectControlProps={{
                        label: "Estado",
                        onChange: async (value: any) => {
                            apiHasBeenCalledRef.current = false;
                            setFilterApprovalStatus(value);
                        },
                        options: [
                            {label: "Pendientes", value: "Todos"},
                            {label: "Rechazados", value: "rejected"},
                        ],
                        value: filterApprovalStatus,
                    }}
                    cardComponent={{
                        imageData: {
                            descriptionRowName: "createdByName",
                        },
                        cardContent: (row) => {
                            return (
                                <CardContent style={{padding: "0 1rem 1rem 1rem"}}>
                                    <Typography variant="body2" color="text.primary" marginBottom=".5rem">
                                        Estado: {!row.approvalStatus 
                                                    ? "Pendiente"
                                                    : "Rechazado"} 
                                    </Typography>
                                    <Typography variant="body2" style={{lineHeight: "1.5em"}}>
                                        Publicado el: {getDatestring(new Date(row.createdAt * 1000))}
                                    </Typography>
                                    <Typography variant="body2" style={{lineHeight: "1.5em"}}>
                                        Nivel de autorización: {row.authorizationLevelName || "Todos"}
                                    </Typography>
                                    <Typography variant="body2">
                                        Texto: {row.text}
                                    </Typography>   
                                    <Typography variant="body2">
                                        Archivos media: {row.mediaUrls?.length || 0}
                                    </Typography>                                          
                                    <Grid
                                        container
                                        padding={0}
                                        spacing={0}
                                        marginTop=".5rem"
                                        direction="row"
                                        textAlign="end"
                                    >
                                        
                                        <Grid item>
                                            <HandleActions row={row} />
                                        </Grid>
                                    </Grid>
                                </CardContent>
                            );
                        }
                    }}
                    tableOptionsBar={{
                        useDrawer: true,
                    }}
                />
            </Paper>
            <MySnackbar 
                open={errorMsg !== ""}
                msg={errorMsg}
                severity="error"
                onClose={() =>  setErrorMsg("")} 
            />
            <MySnackbar 
                open={successMsg !== ""}
                msg={successMsg}
                severity="success"
                onClose={() =>  setSuccessMsg("")} 
            />
            {postData && <Dialog
                open={postData !== null}
                aria-labelledby="responsive-dialog-title"
            >
                <DialogContent style={{width: "100%", height: "50%", padding: "0 1.5rem", textAlign: "center"}}>
                    <PostCard
                        postData={postData} 
                        setErrorMsg={() => {}} 
                        setSuccessMsg={() => {}}
                        disableElevation={true}
                        onlyView={true}
                    />
                </DialogContent>
                <DialogActions>
                    <Grid container>
                    <Grid item margin={"1.5rem 1.5rem 2.5rem 1.5rem"} padding={0} textAlign="center" xs={12}>
                        <Button 
                            variant="contained" 
                            style={{width: "8rem"}}
                            startIcon={<CheckIcon style={{height: "1rem"}} />}
                            onClick={() => setPostData(null)}
                        >
                            Aceptar
                        </Button>
                    </Grid>
                    </Grid>
                </DialogActions>
            </Dialog>}
        </Grid>
    )
}

export default ApprovePosts;